import { DefaultService } from '@/services/DefaultService';

export default class MeusPromotoresSerivce extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    getRoutes(id, dataRota) {
        return this._http.get(`${this._env}/mypromoters/${id}/route.json?data=${dataRota}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getPromotores(info) {
        return this._http.get(encodeURI(`${this._env}/mypromoters.json?page=${info.page > 0 ? info.page - 1 : 0}&limit=${info.limit}&situacao=${info.situacao.id}&param=${info.param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}